import { ComponentProps } from 'react'

import Icon from '~components/ui/icon'

import { cn } from '~utils/cn'

type Props = Readonly<
  ComponentProps<'button'> & {
    onClose: () => void
  }
>

const DialogCloseIcon = ({ className, onClose }: Props) => {
  return (
    <button
      aria-label="close-button"
      type="button"
      onClick={onClose}
      className={cn('absolute right-2 top-2 p-2', className)}
    >
      <Icon name="close" className="size-6 fill-gray-700 dark:fill-white" />
    </button>
  )
}

export default DialogCloseIcon
